export interface VideoArticle {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  thumbnail: string;
  date: string;
  views: number;
  likes: number;
  duration: string;
  tags: string[];
  author: string;
  featured: boolean;
  hot: boolean;
}

export const videoArticles: VideoArticle[] = [
  {
    id: 1,
    title: '2026年度最受欢迎福利视频TOP10合集',
    excerpt: '盘点本年度最受观众喜爱的十大福利视频，涵盖影视综艺、音乐舞台等多个领域，每一部都让人大呼过瘾，绝对不容错过的年度盘点。',
    content: '<p>2026年已经过半，让我们一起来回顾这一年中最受观众欢迎的福利视频TOP10。这些视频凭借精彩的剪辑、丰富的内容和独特的视角，赢得了无数观众的青睐。</p><h2>第一名：热播剧独家幕后花絮</h2><p>这部热播剧的幕后花絮让观众看到了演员们在片场的真实状态，从认真对戏到搞笑互动，每一个画面都充满了惊喜。该视频上线仅三天就突破了百万播放量。</p><h2>第二名：音乐节全场精华回顾</h2><p>今年最火爆的音乐节全场精华，将十几个小时的演出浓缩为三十分钟的精彩集锦，让无法到场的乐迷也能感受到现场的热烈氛围。</p><h2>第三名：综艺节目未播出片段</h2><p>这档热门综艺的未播出片段曝光后引发热议，节目组的用心制作和嘉宾之间的真实互动让这个视频成为了年度热议话题之一。</p><p>以上是前三名的精彩内容，完整榜单请继续观看本页后续推荐的各分类精选视频，每一部都值得你花时间欣赏。</p>',
    category: 'hot',
    thumbnail: 'https://readdy.ai/api/search-image?query=Top%2010%20most%20popular%20videos%20of%20the%20year%20compilation%2C%20cinematic%20award%20style%20with%20golden%20trophy%20and%20spotlight%20on%20dark%20stage%2C%20warm%20golden%20and%20crimson%20lighting%2C%20elegant%20presentation%2C%20soft%20background%20with%20bokeh%20effects%2C%20premium%20quality&width=800&height=450&seq=video-thumb-01&orientation=landscape',
    date: '2026-08-01',
    views: 1258000,
    likes: 89200,
    duration: '15:28',
    tags: ['年度盘点', 'TOP10', '热门合集', '福利视频'],
    author: '福利君',
    featured: true,
    hot: true,
  },
  {
    id: 2,
    title: '独家揭秘：年度热播大剧拍摄现场花絮',
    excerpt: '带你走进年度热播大剧的拍摄现场，揭秘演员们的真实幕后生活，搞笑NG片段和暖心互动全收录，粉丝绝对不能错过。',
    content: '<p>年度热播大剧《长安风云》的拍摄现场花絮终于来啦！我们独家探班剧组，记录了演员们在拍摄间隙的真实状态。</p><h2>片场趣事</h2><p>主演们在拍摄间隙的搞笑互动让人忍俊不禁。一段经典的NG花絮中，男主演连续吃了三次NG，原因竟然是因为一只误入片场的小猫。</p><h2>幕后英雄</h2><p>除了演员，我们还拍摄了剧组工作人员的辛勤付出。从服装道具到灯光摄影，每一个环节都凝聚着团队的汗水。这部花絮视频让你看到银幕背后最真实的剧组生活。</p>',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20popular%20Chinese%20drama%20film%20set%2C%20actors%20laughing%20between%20takes%2C%20warm%20studio%20lighting%2C%20professional%20film%20cameras%20and%20equipment%2C%20casual%20atmosphere%2C%20cinematic%20documentary%20style%2C%20soft%20warm%20tones&width=800&height=450&seq=video-thumb-02&orientation=landscape',
    date: '2026-07-28',
    views: 985000,
    likes: 67200,
    duration: '22:15',
    tags: ['影视花絮', '幕后', '独家', '热播剧'],
    author: '片场探秘',
    featured: true,
    hot: true,
  },
  {
    id: 3,
    title: '明星演唱会精华：万人合唱经典金曲',
    excerpt: '当红歌手巡回演唱会精彩片段合集，万人齐唱经典金曲场面震撼，舞台效果炸裂，带你身临其境感受音乐的魅力。',
    content: '<p>今年最火爆的巡回演唱会精华合集来啦！歌手在舞台上倾情演绎多首经典金曲，万人合唱的场面令人动容。</p><h2>经典曲目回顾</h2><p>从出道曲到最新单曲，每一首歌都勾起了歌迷们的美好回忆。特别是在演唱那首经典情歌时，全场观众自发打开手机闪光灯，营造出一片星海的浪漫氛围。</p><h2>舞台视觉盛宴</h2><p>本次巡演的舞台效果堪称顶级，LED巨幕配合激光灯光秀，每一个画面都美如画。这段精华视频完美捕捉了现场的震撼与感动。</p>',
    category: 'music',
    thumbnail: 'https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20crowd%20holding%20phone%20lights%2C%20singer%20performing%20on%20stage%2C%20dramatic%20stage%20lighting%20with%20colorful%20lasers%2C%20sea%20of%20audience%20lights%2C%20epic%20atmosphere%2C%20warm%20spotlight%2C%20professional%20concert%20photography&width=800&height=450&seq=video-thumb-03&orientation=landscape',
    date: '2026-07-25',
    views: 756000,
    likes: 54300,
    duration: '18:42',
    tags: ['演唱会', '金曲', '合唱', '音乐'],
    author: '音乐现场',
    featured: true,
    hot: true,
  },
  {
    id: 4,
    title: '综艺搞笑名场面合集：笑到停不下来',
    excerpt: '各大热门综艺中最搞笑的未播出片段大合集，艺人真实反应令人捧腹，每一段都是经典中的经典。',
    content: '<p>本期精选各大热门综艺中最搞笑的未播出片段，保证让你笑到停不下来！</p><h2>游戏环节翻车现场</h2><p>多档综艺的游戏环节中，艺人们的真实反应被完整记录下来。有人因为太投入而摔倒，有人因为答错题而崩溃，各种意外状况层出不穷，笑料不断。</p><h2>嘉宾即兴发挥</h2><p>综艺老手们的即兴发挥总是节目中最精彩的部分。一段未被剪入正片的即兴小品，展现了艺人超强的临场反应能力，让人看得拍案叫绝。</p>',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Funny%20variety%20show%20moments%20with%20celebrities%20laughing%20hysterically%2C%20colorful%20studio%20set%20with%20bright%20lights%2C%20comedic%20expressions%2C%20playful%20atmosphere%2C%20warm%20studio%20lighting%2C%20entertaining%20game%20show%20scene&width=800&height=450&seq=video-thumb-04&orientation=landscape',
    date: '2026-07-22',
    views: 689000,
    likes: 48700,
    duration: '12:35',
    tags: ['综艺', '搞笑', '名场面', '未播出'],
    author: '综艺达人',
    featured: false,
    hot: true,
  },
  {
    id: 5,
    title: '精彩足球赛事：年度最佳进球集锦',
    excerpt: '精选全年最精彩的足球比赛进球瞬间，世界波、倒钩、远射应有尽有，足球迷的视觉盛宴。',
    content: '<p>本年度最精彩的足球进球集锦来了！从五大联赛到国际赛事，我们为你精选了全年最令人惊叹的进球瞬间。</p><h2>世界波合集</h2><p>多记精彩绝伦的世界波让人叹为观止。无论是禁区外的凌空抽射，还是小角度的精妙弧线球，每一个进球都展现了顶级球员的超强能力。</p><h2>经典倒钩回顾</h2><p>倒钩进球永远是足球场上最令人激动的瞬间之一。本期收录的三记倒钩进球，每一个都可以成为教科书级别的示范。</p>',
    category: 'sports',
    thumbnail: 'https://readdy.ai/api/search-image?query=Exciting%20football%20soccer%20goal%20scoring%20moment%20with%20player%20kicking%20in%20mid%20air%2C%20stadium%20floodlights%2C%20green%20grass%20field%2C%20dramatic%20sports%20action%20shot%2C%20professional%20sports%20photography%2C%20warm%20evening%20light&width=800&height=450&seq=video-thumb-05&orientation=landscape',
    date: '2026-07-20',
    views: 562000,
    likes: 39100,
    duration: '10:18',
    tags: ['足球', '进球', '集锦', '体育'],
    author: '体育先锋',
    featured: false,
    hot: false,
  },
  {
    id: 6,
    title: '新番推荐：本季最值得追的动漫作品',
    excerpt: '为你盘点本季最值得追看的动漫新番，从热血战斗到治愈日常，全方位覆盖你的动漫口味。',
    content: '<p>本季新番数量众多，我们从数十部作品中精选出最值得追看的几部，帮你快速找到心仪的作品。</p><h2>热血战斗番推荐</h2><p>如果你喜欢燃到爆的战斗场面，本季这两部作品绝对不能错过。顶级的作画质量和紧凑的剧情节奏，每一集都让人意犹未尽。</p><h2>治愈日常番推荐</h2><p>想要放松心情？这几部治愈系日常番画风清新，剧情温暖，是最佳的下饭选择。精美的画面配合舒缓的音乐，让你沉浸在温馨的动漫世界中。</p>',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20style%20illustration%20with%20various%20characters%20from%20different%20anime%20series%2C%20vibrant%20manga%20art%20style%2C%20Japanese%20animation%20aesthetic%2C%20cherry%20blossom%20petals%2C%20warm%20pastel%20color%20palette%2C%20clean%20composition&width=800&height=450&seq=video-thumb-06&orientation=landscape',
    date: '2026-07-18',
    views: 445000,
    likes: 31200,
    duration: '14:50',
    tags: ['动漫', '新番', '推荐', '二次元'],
    author: '动漫迷',
    featured: false,
    hot: false,
  },
  {
    id: 7,
    title: '电竞赛事精彩操作：丝血反杀名场面',
    excerpt: '顶级电竞赛事中那些令人窒息的操作瞬间，丝血反杀、完美团战、极限逃生，电竞爱好者的必看合集。',
    content: '<p>电竞比赛的魅力就在于那些出人意料的精彩操作。本期我们精选了近期各大电竞赛事中最为经典的画面。</p><h2>丝血反杀合集</h2><p>在只剩一丝血量的情况下完成反杀，这需要超强的心理素质和精准的操作。本期收录的五个丝血反杀镜头，每一个都足以载入电竞史册。</p><h2>完美团战解析</h2><p>一场团战的胜负往往取决于一瞬间的判断。我们为你解析近期最精彩的几场团战，从走位到技能释放，每个细节都值得反复品味。</p>',
    category: 'game',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20esports%20gaming%20moment%20with%20professional%20players%20at%20keyboard%2C%20colorful%20RGB%20gaming%20setup%20with%20monitors%2C%20intense%20competitive%20atmosphere%2C%20stadium%20crowd%20in%20background%2C%20dramatic%20lighting%2C%20warm%20and%20cool%20contrast&width=800&height=450&seq=video-thumb-07&orientation=landscape',
    date: '2026-07-15',
    views: 389000,
    likes: 27800,
    duration: '08:55',
    tags: ['电竞', '精彩操作', '反杀', '团战'],
    author: '电竞观察',
    featured: false,
    hot: false,
  },
  {
    id: 8,
    title: '生活小妙招：30个让你相见恨晚的家居技巧',
    excerpt: '整理收纳、清洁保养、厨房妙招全收录，这些简单实用的家居技巧让你的生活更加轻松高效，学会一个就赚到。',
    content: '<p>本期为大家整理了30个超实用的生活小妙招，每一个都简单易学，让你的日常生活变得更加轻松便利。</p><h2>厨房妙招篇</h2><p>从快速剥蒜到食材保鲜，这些厨房妙招帮你节省大量时间。学会之后，做饭效率至少提升一倍。</p><h2>清洁收纳篇</h2><p>家里的卫生死角总是让人头疼？试试这些清洁技巧，让你轻松应对各种清洁难题。搭配收纳妙招，让家里焕然一新。</p>',
    category: 'lifestyle',
    thumbnail: 'https://readdy.ai/api/search-image?query=Clean%20organized%20modern%20home%20interior%20with%20warm%20lighting%2C%20kitchen%20and%20living%20space%20with%20storage%20solutions%2C%20cozy%20minimalist%20Scandinavian%20style%2C%20soft%20natural%20light%20through%20windows%2C%20tidy%20and%20aesthetic%20setup&width=800&height=450&seq=video-thumb-08&orientation=landscape',
    date: '2026-07-12',
    views: 521000,
    likes: 36500,
    duration: '20:30',
    tags: ['生活', '妙招', '家居', '实用'],
    author: '生活达人',
    featured: false,
    hot: true,
  },
  {
    id: 9,
    title: '古装大剧精彩片段：权谋与情感的交织',
    excerpt: '年度古装大剧中那些令人回味无穷的经典片段，权谋斗争的精彩对弈和情感线的发展，每一帧都值得细细品味。',
    content: '<p>年度古装大剧《长安风云》中有太多令人印象深刻的片段。本期我们精选了其中最具代表性的场景，与大家一同回味。</p><h2>朝堂权谋</h2><p>剧中朝堂之上的权谋对弈堪称经典。老戏骨的精湛演技将人物内心的复杂矛盾展现得淋漓尽致，每一段对白都暗藏玄机。</p><h2>情感纠葛</h2><p>除了权谋主线，剧中人物之间的情感牵绊同样打动人心。男女主角之间若即若离的感情线，让无数观众牵肠挂肚。</p>',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20scene%20with%20elaborate%20costumes%2C%20royal%20court%20setting%20with%20warm%20candlelight%2C%20traditional%20Chinese%20architecture%20interior%2C%20dramatic%20atmosphere%2C%20actors%20in%20traditional%20hanfu%20clothing%2C%20cinematic%20lighting&width=800&height=450&seq=video-thumb-09&orientation=landscape',
    date: '2026-07-10',
    views: 678000,
    likes: 45200,
    duration: '25:10',
    tags: ['古装剧', '权谋', '情感', '经典片段'],
    author: '剧评人',
    featured: true,
    hot: false,
  },
  {
    id: 10,
    title: '户外音乐节现场直击：嗨翻全场的狂欢之夜',
    excerpt: '夏季最火爆的户外音乐节全程记录，多个乐队轮番登台献唱，现场氛围燃爆，让你隔着屏幕也能感受到音乐的热情。',
    content: '<p>这个夏天最令人期待的音乐节终于来啦！我们带着摄像机全程记录了这场音乐盛宴的精彩瞬间。</p><h2>开场炸裂</h2><p>音乐节以本土知名摇滚乐队的开场拉开了序幕。几首经典曲目瞬间点燃了现场气氛，观众们随着节奏尽情摇摆，整个草地变成了欢乐的海洋。</p><h2>压轴大秀</h2><p>当晚的压轴表演由特邀嘉宾带来。当熟悉的旋律响起，全场万人大合唱的场面令人动容，这是属于音乐的美好夜晚。</p>',
    category: 'music',
    thumbnail: 'https://readdy.ai/api/search-image?query=Outdoor%20music%20festival%20at%20sunset%20with%20large%20crowd%20dancing%2C%20band%20performing%20on%20main%20stage%2C%20colorful%20stage%20lights%2C%20festival%20atmosphere%20with%20flags%20and%20banners%2C%20warm%20golden%20hour%20lighting%2C%20vibrant%20summer%20vibe&width=800&height=450&seq=video-thumb-10&orientation=landscape',
    date: '2026-07-08',
    views: 834000,
    likes: 59800,
    duration: '28:45',
    tags: ['音乐节', '现场', '演出', '狂欢'],
    author: '音乐现场',
    featured: false,
    hot: true,
  },
  {
    id: 11,
    title: '爆笑综艺游戏环节：明星们的翻车现场',
    excerpt: '多档综艺节目中最搞笑的游戏挑战环节，明星们在游戏中的真实表现让人笑出腹肌。',
    content: '<p>综艺节目中的游戏环节永远是笑料最多的地方。本期我们汇集了近期各大综艺中最搞笑的游戏翻车现场。</p><h2>体能挑战</h2><p>当明星们面对体能挑战时，各种意外的摔倒和搞笑的姿势让人忍俊不禁。有人信心满满地挑战，却在第一关就败下阵来。</p><h2>智趣问答</h2><p>脑筋急转弯环节中，明星们的答非所问让人笑得停不下来。有些答案的离谱程度简直超出想象。</p>',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Celebrities%20playing%20funny%20physical%20challenge%20games%20on%20variety%20show%2C%20colorful%20obstacle%20course%20set%2C%20comedic%20expressions%20and%20poses%2C%20bright%20studio%20lighting%2C%20playful%20and%20energetic%20atmosphere&width=800&height=450&seq=video-thumb-11&orientation=landscape',
    date: '2026-07-05',
    views: 567000,
    likes: 38900,
    duration: '11:20',
    tags: ['综艺', '游戏', '搞笑', '翻车'],
    author: '综艺达人',
    featured: false,
    hot: false,
  },
  {
    id: 12,
    title: '篮球赛场：赛季最燃扣篮合集',
    excerpt: 'NBA和CBA赛季中那些让人热血沸腾的暴力扣篮瞬间，空中接力、战斧劈扣应有尽有。',
    content: '<p>篮球场上最令人热血沸腾的瞬间莫过于一记漂亮的扣篮。本期为你盘点本赛季最精彩的扣篮瞬间。</p><h2>NBA扣篮王</h2><p>NBA赛场上的扣篮永远是最高水平的代表。从空中接力到单手战斧，每一个扣篮都展现了球员惊人的弹跳和身体控制能力。</p><h2>CBA精彩集锦</h2><p>国内CBA联赛同样不乏精彩的扣篮表演。本土球员的暴力扣篮同样令人惊叹，展现了国内篮球水平的飞速提升。</p>',
    category: 'sports',
    thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20player%20performing%20spectacular%20dunk%20in%20arena%2C%20action%20sports%20photography%2C%20indoor%20court%20with%20bright%20stadium%20lights%2C%20dynamic%20mid-air%20pose%2C%20warm%20arena%20atmosphere%2C%20professional%20sports%20photography&width=800&height=450&seq=video-thumb-12&orientation=landscape',
    date: '2026-07-03',
    views: 412000,
    likes: 29100,
    duration: '09:40',
    tags: ['篮球', '扣篮', 'NBA', '体育'],
    author: '体育先锋',
    featured: false,
    hot: false,
  },
];